// Produse echivalente — al doilea furnizor (28 sep 2026, Dan: „o echivalare a unsorilor ca să
// avem un al doilea furnizor"). Produsul aprobat stă în catalogul mașinii cu `echivalent_pentru`
// = codul produsului pe care îl poate înlocui și e legat de aceleași lucrări. În lista de piese
// a unei lucrări se arată lângă acela, ca „sau", nu ca încă un produs de luat.

export interface GrupPiesa {
    p: any;
    alternative: any[];
}

const _cod = (x: unknown): string => String(x || '').replace(/\s/g, '');

/** Grupează lista de piese a unei lucrări: fiecare produs, cu echivalentele lui alături.
 *  Un echivalent al cărui produs de bază nu e în listă rămâne pe rândul lui. */
export function grupeazaEchivalente(parts: any[]): GrupPiesa[] {
    const grupuri: GrupPiesa[] = [];
    const dupaCod = new Map<string, GrupPiesa>();
    const alternative: any[] = [];
    for (const p of parts || []) {
        if (p && p.echivalent_pentru) { alternative.push(p); continue; }
        const g: GrupPiesa = { p, alternative: [] };
        grupuri.push(g);
        const cod = _cod(p && p.part_number);
        if (cod && !dupaCod.has(cod)) dupaCod.set(cod, g);
    }
    for (const a of alternative) {
        const g = dupaCod.get(_cod(a.echivalent_pentru));
        if (g) g.alternative.push(a);
        else grupuri.push({ p: a, alternative: [] });
    }
    return grupuri;
}

/** Aceeași listă, plată, cu fiecare echivalent imediat după produsul lui (`_sau` = e alternativă). */
export function ordoneazaCuEchivalente(parts: any[]): any[] {
    const out: any[] = [];
    for (const g of grupeazaEchivalente(parts)) {
        out.push(g.p);
        for (const a of g.alternative) out.push(Object.assign({}, a, { _sau: true }));
    }
    return out;
}
